<template>
    <SurveyStepWrapper>
        <template
            v-if="taskHandler.isIntroStep"
            #content
        >
            <MrButton
                data-cy="survey-info-step-button"
                :text="buttonText"
                @click="onButton"
            />
        </template>

        <template #header>
            <SurveyInfoStepOutroHeader
                v-if="taskHandler.isOutroStep"
                :view-model="outroStepViewModel"
                :step="taskHandler.currentStep"
                :step-result="taskHandler.currentStepResult"
            />
        </template>

        <template #bottomText>
            <MrMarkdown
                v-if="bottomText"
                class="mr:survey-step-component"
                :html="true"
                :source="bottomText"
            />

            <div
                v-if="taskHandler.isOutroStep"
                class="mr:mt-6 md:mr:mt-8"
            >
                <MrButton
                    data-cy="survey-info-step-button"
                    :text="buttonText"
                    @click="onButton"
                />
            </div>
        </template>
    </SurveyStepWrapper>
</template>

<script setup>
import { computed } from 'vue'
import Locale from '@serv/Locale'
import MrButton from '@comp/MrButton.vue'
import MrMarkdown from '@comp/MrMarkdown.vue'
import SurveyInfoStepOutroHeader from '@comp/survey/SurveyInfoStepOutroHeader.vue'
import SurveyStepWrapper from '@comp/survey/SurveyStepWrapper.vue'
import { useStore } from 'vuex'

// intro step actions
const emits = defineEmits('nextStep')
const store = useStore()
const taskHandler = computed(() => store.getters.taskHandler)

const bottomText = computed(() => {
    if (taskHandler.value.isOutroStep) {
        if (taskHandler.value.numSkippedSteps > 0) {
            return Locale.getLanguageItem('patientSurveyOutroFooterSkipped', [
                taskHandler.value.numSkippedSteps,
                Locale.getLanguageItem('patientSurveyNavPrev')
            ])
        }

        return Locale.getLanguageItem('patientSurveyOutroFooter', [
            Locale.getLanguageItem('patientSurveyNavSubmit'),
            Locale.getLanguageItem('patientSurveyNavPrev')
        ])
    }

    return ''
})

const buttonText = computed(() => {
    if (taskHandler.value.isOutroStep) {
        return Locale.getLanguageItem('submit')
    }

    return taskHandler.value.currentStep.keyValues.buttonText || Locale.getLanguageItem('ok')
})

// outro step data
const outroStepViewModel = computed(() => taskHandler.value.getOutroHeaderViewModel())

const onButton = () => {
    if (taskHandler.value.isLastStep) {
        emits('nextStep')
    } else {
        taskHandler.value.nextStep()
    }
}
</script>
